import React from 'react';
import { Link } from 'react-router-dom';
import { Layers, Wrench, Car, Gauge, Check, ArrowRight } from 'lucide-react';
import { IMAGES, SERVICES } from '../mock';

const iconMap = { Layers, Wrench, Car, Gauge };

const serviceDetails = {
  carbon: ['Pre-preg dry carbon', 'Autoclave cured', 'CNC cut & trimmed', 'UV clear coat', 'OEM-grade fitment'],
  fab: ['Tubular fabrication', 'Roll cages & bars', 'Prototype aero', 'Custom exhausts', 'One-off panels'],
  aero: ['CFD-informed design', 'Downforce tuning', 'Track-tested profiles', 'Balanced styling', 'Fender & widebody work'],
  perf: ['Suspension tuning', 'Brake upgrades', 'Wheel & tire sizing', 'Track alignment', 'Power & tuning'],
};

const Services = () => {
  return (
    <div className="bg-black text-white">
      <section
        className="relative pt-40 pb-24"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.9), rgba(0,0,0,0.7)), url(${IMAGES.carbonHood})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="font-display tracking-[0.3em] text-xs text-[#FF6B00] font-semibold mb-3">SERVICES</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tight max-w-3xl">WHAT WE BUILD. HOW WE BUILD IT.</h1>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 space-y-20">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.icon] || Wrench;
            const reverse = i % 2 === 1;
            const image = [IMAGES.carbonHood, IMAGES.fabrication, IMAGES.supra, IMAGES.wheelPerf][i % 4];
            return (
              <div key={s.id} className={`grid lg:grid-cols-2 gap-10 items-center ${reverse ? 'lg:[&>div:first-child]:order-2' : ''}`}>
                <div>
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={image} alt={s.title} className="w-full h-full object-cover" />
                  </div>
                </div>
                <div>
                  <Icon className="text-[#FF6B00] mb-5" size={36} strokeWidth={1.5} />
                  <div className="font-display tracking-[0.3em] text-xs text-[#FF6B00] font-semibold mb-2">0{i + 1}</div>
                  <h2 className="font-display text-3xl md:text-4xl tracking-tight mb-4">{s.title.toUpperCase()}</h2>
                  <p className="text-neutral-300 leading-relaxed mb-6">{s.desc}</p>
                  <ul className="space-y-3">
                    {serviceDetails[s.id]?.map((item) => (
                      <li key={item} className="flex items-center gap-3 text-sm text-neutral-200">
                        <Check size={16} className="text-[#FF6B00]" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* RED CTA BANNER */}
      <section className="relative overflow-hidden bg-[#FF6B00] text-white">
        <div
          className="absolute inset-0 opacity-10 pointer-events-none"
          style={{
            backgroundImage: `url(${IMAGES.carbonTexture})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            mixBlendMode: 'overlay',
          }}
        />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-20 grid lg:grid-cols-[1fr_auto] gap-8 items-center">
          <div>
            <div className="font-display tracking-[0.3em] text-[11px] text-white/80 font-semibold mb-3">QUESTIONS?</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              NEED MORE INFO?<br />
              WE&rsquo;RE HERE TO HELP.
            </h2>
            <p className="text-white/90 mt-5 max-w-xl leading-relaxed">
              Have a question about a product, fitment, or lead times? Our team is happy to walk you through every detail before you commit.
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 bg-white text-[#FF6B00] hover:bg-black hover:text-white transition-colors px-8 py-5 font-display tracking-[0.22em] text-sm font-bold"
            >
              CONTACT US
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
